import React, { useState, useEffect, useLayoutEffect } from 'react';
import Select from "react-select";
import { Link } from 'react-router-dom';
import {Container, Row, Col, ProgressBar, Form, Button, Accordion, Card, InputGroup} from 'react-bootstrap';
import CustomProgressBar from '../../../components/customPorgressBar/CustomProgressBar';
import Icon from "react-crypto-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowAltCircleDown, faArrowAltCircleUp} from '@fortawesome/free-regular-svg-icons';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';

  
import * as s from './Bitcoin.style';

const Bitcoin = props => {
    const progressData = [
        {bgcolor:'#0d6efd', completed:15, label:true},
        {bgcolor:'#fd470d', completed:30, label:false},
        {bgcolor:'#bdbdbd', completed:55, label:true},
    ];
    const [selectedOption, setSelectedOption] = useState("USDT");
    const options = [
        {
          value: "USDT",
          label: (
            <div>
              <Icon name="usdt" className="mr-2" size={18}/> USDT
            </div>
          )
        },
        {
          value: "ETH",
          label: (
            <div>
              <Icon name="eth" className="mr-2" size={18}/> ETH
            </div>
          )
        },
        {
          value: "vanilla",
          label: (
            <div>
              <Icon name="matic" className="mr-2" size={18}/> MATIC
            </div>
          )
        }
    ];
    const handleTypeSelect = e => {
        setSelectedOption(e.value);
    };
    
  return (
    <s.Container className='pl-0 pt-0'>
        <Container fluid={true}>
            <Row>
                <Col xs={12} md={7} className='bg-white' style={{minHeight:'100vh'}}>
                    <s.AccountPanelTitle className='mt-3'>Insurance Account</s.AccountPanelTitle> 
                    <div className='mb-5'></div>
                    <span className="dot bg-primary mr-3"></span><small>current: 15%</small><span className="dot bg-danger ml-2 mr-3"></span><small className='mr-3'>Ideal: 20%</small> <a href='#' className='.text-decoration-none'>Change</a>
                    <CustomProgressBar config={progressData} height={50}/>
                    <div className='mb-5'></div>
                    <div className='mb-5'></div>
                    <s.LiquidationContent className='vertical-center-space-around'>
                        <s.LiquidationCard className='text-center'>
                            <Button variant='outline-primary' size='md' >Edit Ideal Insurance Ratio</Button>
                        </s.LiquidationCard>
                        <s.LiquidationResult>
                            <s.AccountPanelTitle>Buffer for liquidation(multiplaying account)</s.AccountPanelTitle> 
                            <small>current: 15%</small><small className='float-right'>Ideal: 20%</small>
                            <ProgressBar now={90} />
                            <div className='mb-3'></div>
                        </s.LiquidationResult>
                    </s.LiquidationContent>
                    <s.LiquidationContent className='mb-3 mt-3'>
                        <s.LiquidationResult>
                            <s.AccountPanelTitle>result</s.AccountPanelTitle> 
                            <div className='mb-3'></div>
                            <s.H3>sell</s.H3>
                            <h2>$ 4096$ (1.5ETH)</h2>
                            <div className="mb-3 mt-3">
                                <Form.Check 
                                    type="radio"
                                    id="pay-radio"
                                    label="Pay fee, Earn Cimple (0.0001ETH)"
                                />
                                <div className='mb-2'></div>
                                <Form.Check
                                    type="radio"
                                    id="pay-radio"
                                    label="Pay Cimple"
                                />
                                <div className='mb-4'></div>
                                <Button className='btn btn-warning pl-5 pr-5 py-1' style={{backgroundColor:'#ff926e', color:"white"}} size='lg'>Sell</Button>
                            </div>
                        </s.LiquidationResult>
                        <s.LiquidationCard>
                            <s.AccountPanelTitle>yield</s.AccountPanelTitle> 
                            <s.LiquidationInformationCard>
                                <div className="card border-left-0 border-top-0">
                                    <div className="card-body text-center">
                                        <div className='card-deck'>
                                            <div className="card border-0">
                                                <div className="card-body text-center">
                                                    <small className='text-muted'>Supplied</small>
                                                    <h6>74,966 DAI</h6>
                                                    <div>
                                                        <FontAwesomeIcon icon={faArrowAltCircleUp} color="#20c997" size="sm" />
                                                        4 %
                                                        <Icon name="matic" className="ml-2" size={12}/>
                                                        1 %
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card border-0">
                                                <div className="card-body text-center">
                                                    <small className='text-muted'>Borrowed</small>
                                                    <h6>54,996 DAI</h6>
                                                    <div>
                                                        <FontAwesomeIcon icon={faArrowAltCircleDown} color="#eb5757" size="sm" />
                                                        4 %
                                                        <Icon name="matic" className="ml-2" size={12}/>
                                                        1 %
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            <div className="card border-0 vertical-center">
                                                <div className="card-body text-center vertical-center">
                                                    <div>
                                                        <Icon name="dai" size={40}/>
                                                        <div className='mb-1'></div>
                                                        <a href='#' className='text-decoration-none'>Change</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card mt-1 border-0">
                                    <div className="card-body vertical-center-space-between">
                                        <div className='float-left'>
                                            <Icon name="matic" className="mr-2" size={52}/><span className='text-dark'>384</span>
                                        </div>
                                        <div className='float-right text-center'>
                                            <Button variant='primary' className="pl-5 pr-5 py-1" size='lg' style={{width:'200px'}}>Claim</Button>
                                            <Form.Group className="mt-0 mb-0">
                                                <Form.Check type="checkbox" defaultChecked label="Swap & Supply" />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                            </s.LiquidationInformationCard>
                        </s.LiquidationCard>
                    </s.LiquidationContent>
                    
                    <s.LiquidationDataView className='mt-5'>
                        <table className="table">
                            <tbody>
                                <tr className='border-top-0'>
                                    <td>Price</td>
                                    <td>$4000</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>LTV</td>
                                    <td>$20,996</td>
                                    <td><FontAwesomeIcon icon={faArrowAltCircleDown} color="#0d6efd" size="sm" />4 %</td>
                                </tr>
                                <tr>
                                    <td>Token Quantity</td>
                                    <td>40%</td>
                                    <td><FontAwesomeIcon icon={faArrowAltCircleDown} color="#0d6efd" size="sm" />4 %</td>
                                </tr>
                                <tr>
                                    <td>Leveraged Debit</td>
                                    <td>$20,000</td>
                                    <td><FontAwesomeIcon icon={faArrowAltCircleDown} color="#0d6efd" size="sm" />4 %</td>
                                </tr>

                            </tbody>
                        </table>
                    </s.LiquidationDataView>
                </Col>
                <Col xs={12} md={5}>
                    <div className="card mt-3">
                        <div className="card-body">
                            <s.AccountPanelTitle className='mt-3'>Fee based Insurance</s.AccountPanelTitle> 
                            <div className="card d-inline-block mt-3" style={{borderLeft:'5px solid #0069d9'}}>
                                <div className="card-body">
                                    <p className="card-title">Balance Of Insurance Pool</p>
                                    <p className="h6">$250, 000</p>
                                </div>
                            </div>
                            <Form className="mt-3">
                                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                                    <Form.Label column sm="4" md="4">
                                    Liquidation Price
                                    </Form.Label>
                                    <Col sm="4" md="4">
                                    <Form.Control type="number" placeholder="450" />
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                                    <Form.Label column sm="4" md="4">
                                    Amount of coverage
                                    </Form.Label>
                                    <Col sm="4" md="4">
                                    <Form.Control type="number" placeholder="450" />
                                    </Col>
                                </Form.Group>
                            </Form>
                            <s.AccountPanelTitle className='mt-3'>Price</s.AccountPanelTitle> 
                            <InputGroup className="mt-3 mb-3">
                                <Select value={options.filter(function(option) {
                                        return option.value === selectedOption;
                                    })} onChange={handleTypeSelect} options={options} />
                                <Form.Control type="number" placeholder="450" />
                            </InputGroup>
                            <div>
                                <Button variant='primary' size='lg' className="pl-5 pr-5 py-1">Buy Insurance</Button>
                                <FontAwesomeIcon icon={faInfoCircle} className='ml-3 mr-2' color="#0dcaf0" size="lg" /><span>Length: 90 days</span>
                            </div>
                        </div>
                    </div>
                    {/* <div className="card mt-3">
                        <div className="card-body vertical-center-space-around">
                            <div className='float-left'>
                                <Icon name="matic" className="mr-2" size={52}/><span className='text-dark'>200</span>
                            </div>
                            <div className='float-right'>
                                <Button variant='primary' size='md'>Claim, Swap & Supply</Button>
                            </div>
                        </div>
                    </div>
                    <div className='mt-3 mb-3'>
                        <Accordion defaultActiveKey="0">
                            <Card>
                                <Accordion.Toggle as={Card.Header} eventKey="0" style={{cursor:"pointer"}}>
                                    Account Information
                                </Accordion.Toggle>

                                <Accordion.Collapse eventKey="0">
                                    <Card.Body>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
                                        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                                        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                                        commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
                                        velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                                        cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
                                        est laborum.
                                    </Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion>
                    </div> */}
                    <div className='card mb-3'>
                        <div className="card-body">
                            <div className='card table-striped table-borderless border-0 table-responsive'>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Price</th>
                                            <th>LTV</th>
                                            <th>Asset Value</th>
                                            <th>Number of Token</th>
                                            <th>Leveraged Debit</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className='border-top-0'>
                                            <td>$4,000</td>
                                            <td>$2,000</td>
                                            <td>$20,000</td>
                                            <td>30%</td>
                                            <td>$2,000</td>
                                            <td>Sell <br></br>$2,000</td>
                                        </tr>
                                        <tr className='border-top-0'>
                                            <td>$4,000</td>
                                            <td>$2,000</td>
                                            <td>$20,000</td>
                                            <td>30%</td>
                                            <td>$2,000</td>
                                            <td>Sell <br></br>$2,000</td>
                                        </tr>
                                        <tr className='border-top-0'>
                                            <td>$4,000</td>
                                            <td>$2,000</td>
                                            <td>$20,000</td>
                                            <td>30%</td>
                                            <td>$2,000</td>
                                            <td>Sell <br></br>$2,000</td>
                                        </tr>
                                        <tr className='border-top-0'>
                                            <td>$4,000</td>
                                            <td>$2,000</td>
                                            <td>$20,000</td>
                                            <td>30%</td>
                                            <td>$2,000</td>
                                            <td>Sell <br></br>$2,000</td>
                                        </tr>
                                        <tr className='border-top-0'>
                                            <td>$4,000</td>
                                            <td>$2,000</td>
                                            <td>$20,000</td>
                                            <td>30%</td>
                                            <td>$2,000</td>
                                            <td>Sell <br></br>$2,000</td>
                                        </tr>
                                        <tr className='border-top-0'>
                                            <td>$4,000</td>
                                            <td>$2,000</td>
                                            <td>$20,000</td>
                                            <td>30%</td>
                                            <td>$2,000</td>
                                            <td>Sell <br></br>$2,000</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>   
                    </div>
                    
                </Col>
            </Row>
        </Container>
    </s.Container>
  )
}

export default Bitcoin